module.exports = __webpack_public_path__ + "9918798071cacb73cdf87f3103d127fe.svg";